import styled from '@emotion/styled';
import { DataGrid, DataGridProps } from '@mui/x-data-grid';
import theme from 'App.theme';

export enum StyledDataGridClassNames {
  ImplantKitHeader = 'implant-kit-header',
  ImplantKitItem = 'implant-kit-item',
  ImplantKitItemLast = 'implant-kit-item-last',
}

type StyledDataGridProps = DataGridProps & {
  hidePagination?: boolean;
  stickyHeader?: boolean;
};

export const StyledDataGrid = styled(DataGrid, {
  shouldForwardProp: prop => prop != 'hidePagination' && prop !== 'stickyHeader',
})<StyledDataGridProps>`
  .MuiDataGrid-cell:focus {
    outline: none;
  }

  & .MuiDataGrid-row:hover {
    cursor: pointer;
  }

  .MuiDataGrid-main {
    background-color: ${theme.colors.white};
    /* padding: ${theme.layout.spacing.small}; */
    justify-content: left;
  }

  /* Conditional sticky header logic */
  ${props =>
    props.stickyHeader &&
    `
    height: 100% !important;

    & .MuiDataGrid-columnHeaders {
      position: sticky !important;
      top: 0;
      z-index: 1;
    }

    & .MuiDataGrid-main, & .MuiDataGrid-windowContainer, & .MuiDataGrid-window, & .MuiDataGrid-renderingZone {
      overflow: visible !important;
    }
  `}

  .MuiDataGrid-columnHeaders,
  .MuiDataGrid-cell {
    white-space: normal !important;
    word-break: break-word;
    text-align: center;
  }

  .MuiDataGrid-columnHeaders {
    background-color: ${theme.greys.GREY6};
  }

  .MuiCircularProgress-root {
    position: fixed;
    z-index: ${theme.layers.top};
    margin-top: 50px;
  }

  .MuiTablePagination-root {
    /* Display only the 'Rows per page' part */
    display: ${props => (props.hidePagination ? 'none' : 'flex')};
  }

  .MuiTablePagination-displayedRows {
    /* Hide the default pagination controls and row count */
    display: ${props => (props.hidePagination ? 'none' : 'flex')};
    justify-content: space-between;
  }

  .MuiTablePagination-root {
    /* Display only the 'Rows per page' part */
    display: flex;
    justify-content: flex-start;
    padding-top: 16px; /* Add some padding for spacing */
    justify-content: space-between;
  }

  .MuiToolbar-root {
    display: ${props => (props.hidePagination ? 'none' : 'flex')};
  }

  .MuiTablePagination-actions {
    /* Hide the 'Rows per page' label */
    display: ${props => (props.hidePagination ? 'none' : 'flex')};
  }

  .MuiDataGrid-footerContainer {
    display: ${props => (props.hidePagination ? 'none' : 'flex')};
  }

  .MuiDataGrid-toolbarContainer {
    background-color: ${theme.colors.white};
    padding: ${theme.layout.spacing.medium};
    justify-content: space-between;

    > .MuiBox-root {
      display: ${props => (props.hidePagination ? 'none' : 'flex')};
    }
  }

  .${StyledDataGridClassNames.ImplantKitHeader} {
    font-weight: 500;
    background-color: rgba(0, 0, 0, 0.05);
  }

  .${StyledDataGridClassNames.ImplantKitItem} {
  }

  .${StyledDataGridClassNames.ImplantKitItemLast} {
  }
`;
